import * as React from "react";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Snackbar,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PersonIcon from "@mui/icons-material/Person";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, sendOTP } from "../redux/actions/AdminAction";
import { NavLink, useNavigate } from "react-router-dom";
import { SEND_OTP_RESET, USER_LOGIN_RESET } from "../Constants/Constants";

export default function Login(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(props.page);
  const [snackOpen, setSnackOpen] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const emailInputRef = useRef();
  const passwordInputRef = useRef();
  const otpInputRef = useRef();

  const [user, setUser] = useState({ email: "", password: "" });

  const [showPassword, setShowPassword] = React.useState(false);

  const loginResponse = useSelector((state) => state.UserLogin);

  const { token, loginerror } = loginResponse;

  const SendOTPData = useSelector((state) => state.SendOTPData);

  const { sendOTPerror, sendOTPInfo } = SendOTPData;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    sendOTPerror && setPage("login");
    sendOTPInfo && setPage("otp");
  }, [sendOTPerror, sendOTPInfo]);

  const handleEmailValidation = (email) => {
    setEmailError(!emailRegex.test(email));
  };
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    if (token) {
      navigate("/home");
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (page === "login") {
      setSnackOpen(true);
      dispatch({ type: USER_LOGIN_RESET });
      if (
        emailInputRef.current.value &&
        passwordInputRef.current.value &&
        !emailError
      ) {
        // setUser({
        //   email: emailInputRef.current.value,
        //   password: passwordInputRef.current.value,
        // });
        const requestData = {
          email: emailInputRef.current.value,
          password: passwordInputRef.current.value,
          from: "login",
        };
        setUser(requestData);
        dispatch(sendOTP(requestData));
        // setPage("otp");
      }
    }
    if (page === "otp") {
      dispatch({ type: SEND_OTP_RESET });
      setSnackOpen(true);
      if (otpInputRef.current.value) {
        const login_data = { ...user, otp: otpInputRef.current.value };
        dispatch(login(login_data));
      }
    }
  };

  const handleResetOTP = (e) => {
    dispatch({ type: SEND_OTP_RESET });
    dispatch({ type: USER_LOGIN_RESET });
    e.preventDefault();
    const requestData = user;
    dispatch(sendOTP(requestData));
    setSnackOpen(true);
  };

  return (
    <Container sx={{ marginBottom: "5%" }}>
      <Box
        sx={{
          mt: 10,
        }}
      >
        <Grid container spacing={3} sx={{ textAlign: "center" }}>
          <Grid xs={12}>
            <Typography
              sx={{
                fontSize: 30,
                textAlign: "center",
                ml: 3,
                color: "#313639",
              }}
            >
              AGENT LOGIN PORTAL
            </Typography>
          </Grid>
          {page === "login" && (
            <>
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <FormControl
                  variant="outlined"
                  size="medium"
                  error={emailError}
                  sx={{ width: "35%" }}
                >
                  <OutlinedInput
                    required
                    sx={{ height: "8vh" }}
                    placeholder="Email"
                    name="email"
                    inputRef={emailInputRef}
                    onChange={(e) => handleEmailValidation(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <PersonIcon />
                      </InputAdornment>
                    }
                  />
                  {emailError && (
                    <FormHelperText error>Invalid email format</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <FormControl
                  variant="outlined"
                  size="medium"
                  sx={{ width: "35%" }}
                >
                  <OutlinedInput
                    required
                    sx={{ height: "8vh" }}
                    type={showPassword ? "text" : "password"}
                    inputRef={passwordInputRef}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    placeholder="Password"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <NavLink to={"/forgotpassword"}>Forgot Password?</NavLink>
              </Grid>
            </>
          )}
          {page === "otp" && (
            <>
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <OutlinedInput
                  required
                  size="medium"
                  sx={{ width: "35%", height: "8vh" }}
                  type={showPassword ? "text" : "password"}
                  inputRef={otpInputRef}
                  inputProps={{
                    pattern: "[0-9]*",
                  }}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    e.target.value = value;
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  placeholder="One Time Password (OTP)"
                />
              </Grid>
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <NavLink onClick={handleResetOTP}>Reset OTP</NavLink>
              </Grid>
            </>
          )}
          <Grid item xs={12} sx={{ fontSize: 40, textAlign: "center" }}>
            <Button
              type="submit"
              onClick={handleLogin}
              size="small"
              sx={{
                backgroundColor: "#282828",
                border: "1px solid #313639",
                color: "#ffffff",
                width: "35vh",
                height: "8vh",
                mt: 4,
                fontSize: 18,
                "&:hover": {
                  backgroundColor: "#282828",
                  color: "#ffffff",
                },
              }}
            >
              LOGIN
            </Button>
          </Grid>
        </Grid>
        {token && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Success</AlertTitle>
              You have successfully logged in!
            </Alert>
          </Snackbar>
        )}
        {(sendOTPerror || loginerror) && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Error</AlertTitle>
              {sendOTPerror} {loginerror}
            </Alert>
          </Snackbar>
        )}
        {sendOTPInfo && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Success</AlertTitle>
              {sendOTPInfo}
            </Alert>
          </Snackbar>
        )}
      </Box>
    </Container>
  );
}
